module.exports = __webpack_public_path__ + "img/esu-logo.cdfa2ae3.svg";